"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _ClickAwayListener = _interopRequireDefault(require("@material-ui/core/ClickAwayListener"));

var _Popper = _interopRequireDefault(require("@material-ui/core/Popper"));

var _Button = _interopRequireDefault(require("./Button"));

var _context = require("../context");

function Dropdown(_ref, ref) {
  var overlay = _ref.overlay,
      children = _ref.children,
      props = (0, _objectWithoutProperties2["default"])(_ref, ["overlay", "children"]);
  var editor = (0, _context.useEditor)();

  var _useState = (0, _react.useState)(null),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      anchorEl = _useState2[0],
      setAnchorEl = _useState2[1];

  var rootRef = (0, _react.useRef)();
  var open = Boolean(anchorEl);

  var handleClose = function handleClose(e) {
    setAnchorEl(null);
    editor.focus();
  };

  (0, _react.useEffect)(function () {
    if (!editor) return;

    var handleFocusIn = function handleFocusIn(event) {
      setAnchorEl(null);
    };

    editor.on('focusin', handleFocusIn);
    return function () {
      editor.off('focusin', handleFocusIn);
    };
  }, [editor]);
  return /*#__PURE__*/_react["default"].createElement("div", {
    ref: rootRef
  }, /*#__PURE__*/_react["default"].createElement(_Button["default"], (0, _extends2["default"])({}, props, {
    ref: ref,
    active: !!anchorEl,
    onClick: function onClick(e) {
      e.preventDefault();
      setAnchorEl(anchorEl ? null : e.currentTarget);
    }
  }), children), /*#__PURE__*/_react["default"].createElement(_Popper["default"], {
    open: open,
    anchorEl: anchorEl,
    container: function container() {
      return rootRef.current;
    },
    style: {
      zIndex: 1
    }
  }, /*#__PURE__*/_react["default"].createElement(_ClickAwayListener["default"], {
    onClickAway: handleClose
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "shadow w-auto bg-white rounded dark:bg-card dark:shadow-shallow"
  }, /*#__PURE__*/_react["default"].createElement(overlay, {
    onClose: function onClose() {
      return setAnchorEl(null);
    }
  })))));
}

var _default = /*#__PURE__*/(0, _react.forwardRef)(Dropdown);

exports["default"] = _default;
//# sourceMappingURL=Dropdown.js.map